import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailSearch } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../api";
import { Reveal } from "../components/Reveal";

export default function OrderLookup() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/orders/lookup", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err, "Something went wrong — please try again."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-xl px-6 py-20 md:px-8 lg:py-28" data-testid="order-lookup-page">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-sage">Order recovery</p>
        <h1 className="mt-3 font-serif text-4xl font-light tracking-tight text-ink sm:text-5xl">
          Find your downloads
        </h1>
        {sent ? (
          <div className="mt-10 rounded-[1.6rem] border border-sage/15 bg-white/80 p-8" data-testid="lookup-sent">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage-tint text-sage">
              <MailSearch size={20} />
            </span>
            <p className="mt-5 text-sm leading-relaxed text-ink/70">
              If any orders are linked to <strong>{email}</strong>, an email with your personal
              download links is on its way. Check your inbox (and spam folder) in a minute or two.
            </p>
            <Link to="/shop" className="mt-6 inline-block text-sm text-sage underline underline-offset-4">
              Back to the shop
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5">
            <p className="text-sm font-light leading-relaxed text-ink/65">
              Enter the email address you used at checkout and we'll send you fresh links to every
              download you've purchased.
            </p>
            <input
              data-testid="lookup-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full rounded-2xl border border-sage/20 bg-white/80 px-5 py-3.5 text-sm text-ink outline-none transition-colors placeholder:text-ink/35 focus:border-sage"
            />
            <button
              data-testid="lookup-submit-button"
              disabled={busy}
              className="inline-flex items-center gap-3 rounded-full bg-sage px-8 py-4 text-sm font-medium text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-sage-deep disabled:opacity-60"
            >
              {busy ? <Loader2 size={16} className="animate-spin" /> : <MailSearch size={15} />}
              Email my download links
            </button>
          </form>
        )}
      </Reveal>
    </div>
  );
}
